import { render, staticRenderFns } from "./patientAppointment.vue?vue&type=template&id=0d3c7dba&"
import script from "./patientAppointment.vue?vue&type=script&lang=js&"
export * from "./patientAppointment.vue?vue&type=script&lang=js&"
import style0 from "./patientAppointment.vue?vue&type=style&index=0&id=0d3c7dba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports